/**
 * `380` — *set {date, columnId} to today*. Writes `{"date":"YYYY-MM-DD"}`, plus `"time"` when the
 * reference carries `includeTime`. "Today" is UTC here, matching how dates are stored
 * (`column-value-shapes.md` §date); running it twice in one day is a no-op the second time.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { columnRefSchema } from '../values.js';
export const setDateTodayParams = z.object({ columnId: columnRefSchema });
const isoDate = (date) => date.toISOString().slice(0, 10);
const isoTime = (date) => date.toISOString().slice(11, 19);
export const setDateTodayAction = defineAction({
    id: '380',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'set {date, columnId} to today',
    paramsSchema: setDateTodayParams,
    requiredColumnTypes: ['date'],
    executable: true,
    references: (params) => [{ kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid }],
    async execute(context, params) {
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const value = { date: isoDate(context.now) };
        if (params.columnId.includeTime === true)
            value.time = isoTime(context.now);
        const result = await context.services.setCellValue({
            boardId: context.boardId,
            itemId: context.itemId,
            columnId: params.columnId.columnId,
            value,
        });
        return { ...value, changed: result.changed };
    },
});
//# sourceMappingURL=380.js.map